import "./instruccionesSolicitud.scss";
import { memo } from "react";
import { useEffect } from "react";
import Titulo from "../../components/atoms/titles/Titulo";
import Button from "../../components/atoms/buttons/Button";

import { useLocalStorage } from "../../hooks/useLocalStorage";

const InstruccionesSolicitudPopUp = () => {
  const [token] = useLocalStorage("token", "");

  useEffect(() => {}, [token]);

  function volver() {
    window.close()
  }

  function InstruccionesSolicitudPopUp() {
    return (
      <>
        <div className="container d-flex flex-column mt-5" role="main" data-landmark-index="4">
          {/* INFORMACION */}
          <div className="container p-5 bg1Gris m-2">
            <Titulo titulo={"Instrucciones"} tipo={"tituloPagina"} />
            <div className="separador"></div>
            <Titulo
              clases={"subSubTituloSolicitud p-2 fw-bold"}
              tipo={"tituloCard noBg"}
              titulo={"Generales"}
            ></Titulo>
            <div className="separador mb-2"></div>
            <p>
              El formulario de solicitud deberá cumplimentarse y generarse de
              forma electrónica a través de la zona privada del Portal del
              Empleado Público (http://portalempleado.gobex.es). No se admitirá
              ninguna solicitud que no haya sido cumplimentada y generada a
              través de la ruta especificada en este apartado. Además, si la
              persona solicitante alega alguno de los méritos del apartado 2.B
              (que requiere acreditación), una vez cumplimentada y generada la
              solicitud, deberá imprimirla y presentarla junto con los
              correspondientes certificados acreditativos, a través de los
              registros administrativos habilitados al efecto o lugares
              señalados en el artículo 16.4 de la Ley 39/2015, de 1 de octubre,
              del procedimiento administrativo común de las administraciones
              públicas, y en particular, en lo establecido en el artículo 7.1
              del Decreto 257/2009 de 18 de octubre, por el que se implanta un
              sistema de registro único y se regulan las funciones
              administrativas del mismo en el ámbito de la Administración de la
              Comunidad Autónoma de Extremadura, dirigida a la Dirección General
              de Función Pública de la Consejería de Hacienda y Administración
              Pública de la Junta de Extremadura.
            </p>
            <p>
              El reconocimiento de nivel que corresponda se realizará en el
              Cuerpo, Escala o Categoría Profesional en el que se encuentre la
              persona solicitante en el momento de presentar la solicitud.
            </p>
            <p>
              El plazo para resolver y notificar la solicitud será de seis
              meses, entendiéndose desestimada si en dicho plazo no recayera
              resolución expresa. La notificación de la resolución se practicará
              por medios electrónicos en la zona privada del Portal del Empleado
              Público.
            </p>
            <div className="separador"></div>
            <Titulo
              clases={"subSubTituloSolicitud p-2 fw-bold"}
              tipo={"tituloCard noBg"}
              titulo={"Específicas"}
            ></Titulo>
            <div className="separador mb-2"></div>
            <p>
              2.A) Méritos a comprobar de oficio: En el caso de que la persona
              solicitante cumplimente alguno de estos apartados, la
              Administración comprobará de oficio la documentación acreditativa
              de los méritos alegados, eximiendo a la persona solicitante de
              aportarla.
            </p>
            <p>
              A.1.- Formación continua recibida y docencia impartida en la
              Escuela de Administración Pública de Extremadura (EAP): Formación
              certificada por la EAP que se deberá marcar si el/la solicitante
              quiere que se le valore.{" "}
              <span className="fw-bold">NO SE APORTARÁ DOCUMENTACIÓN.</span>
            </p>
            <p>
              A.2.- Puestos de trabajo de especial desempeño: Son aquellos
              puestos de trabajo que reunen alguna de las circunstancias
              establecidas en el Plan de Valoración. NO SE APORTARÁ
              DOCUMENTACIÓN.
            </p>
            <p>
              A.3.- Participación en órganos de selección y/o provisión del
              personal de la Administración de la Junta de Extremadura: Se
              valorará la participación en calidad de presidente/a,
              secretario/a, vocal o asesor/a de los órganos de selección y
              provisión de la Administración General de la Junta de Extremadura.
              La persona solicitante deberá indicar, en su caso, el DOE de su
              nombramiento o de la publicación de la convocatoria de provisión.
              <span className="fw-bold">NO SE APORTARÁ DOCUMENTACIÓN.</span>
            </p>
            <p>
              2.A) Méritos a comprobar de oficio: En el caso de que la persona
              solicitante cumplimente alguno de estos apartados, la
              Administración comprobará de oficio la documentación acreditativa
              de los méritos alegados, eximiendo a la persona solicitante de
              aportarla. A.1.- Formación continua recibida y docencia impartida
              en la Escuela de Administración Pública de Extremadura (EAP):
              Formación certificada por la EAP que se deberá marcar si el/la
              solicitante quiere que se le valore.{" "}
              <span className="fw-bold">NO SE APORTARÁ DOCUMENTACIÓN.</span>
              A.2.- Puestos de trabajo de especial desempeño: Son aquellos
              puestos de trabajo que reunen alguna de las circunstancias
              establecidas en el Plan de Valoración. NO SE APORTARÁ
              DOCUMENTACIÓN. A.3.- Participación en órganos de selección y/o
              provisión del personal de la Administración de la Junta de
              Extremadura: Se valorará la participación en calidad de
              presidente/a, secretario/a, vocal o asesor/a de los órganos de
              selección y provisión de la Administración General de la Junta de
              Extremadura. La persona solicitante deberá indicar, en su caso, el
              DOE de su nombramiento o de la publicación de la convocatoria de
              provisión.{" "}
              <span className="fw-bold">
                NO SE APORTARÁ DOCUMENTACIÓN.
              </span>{" "}
              2.B) Méritos que deben ser acreditados por el/la interesado/a:En
              el caso de que la persona solicitante cumplimente alguno de estos
              apartados (B.1, B.2, B.3), deberá describir el mérito alegado,
              imprir la solicitud y enviarla, junto con los correspondientes
              certificados acreditativos, a la Dirección General de Función
              Pública, a través de alguno de los registros administrativos
              habilitados al efecto. En el caso de la formación continua y
              docencia, el certificado deberá indicar el número de
              créditos/horas, en caso contrario, no serán objeto de valoración.
            </p>
            <div className="direccion d-flex flex-column align-items-center mt-5 text-center">
              <p>DIRECCIÓN GENERAL DE FUNCIÓN PÚBLICA</p>
              <p className="text-center">
                Avda. Valhondo s/n, Edificio III Milenio, Módulo 1- 1ª planta.
                06800 - MÉRIDA
              </p>
            </div>
          </div>
          <Button
            id="anadirParticipacion"
            clases="btn-peque btn-standard col-6 m-5 btnRed"
            nombre={
              <>
                <i className="fa-solid fa-arrow-rotate-left"></i> Cerrar
              </>
            }
            tipo="button"
            funcion={volver}
          />
        </div>
      </>
    );
  }

  return <>{InstruccionesSolicitudPopUp()}</>;
};

export default memo(InstruccionesSolicitudPopUp);
